import { useQuery } from '@tanstack/react-query';
import { apiService } from '../../services/api';
import { queryKeys } from './queryKeys';

export function useUserLeagues() {
  return useQuery({
    queryKey: queryKeys.userLeagues(),
    queryFn: () => apiService.getUserLeagues(),
    staleTime: 2 * 60 * 1000,
    select: (data) => data.leagues,
  });
}
